export function getApiErrorMessage(error, fallbackMessage) {
  const errorMessages = error?.response?.data?.errors
  if (errorMessages) {
    const firstKey = Object.keys(errorMessages)[0]
    if (firstKey && errorMessages[firstKey]?.[0]) {
      return errorMessages[firstKey][0]
    }
  }

  return error?.response?.data?.message ?? error?.response?.data?.error ?? fallbackMessage
}
